import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getEmergencyContact = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMERGENCY_CONTANCT,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
     
    const resp = await client.get(iType === 1 ? '/api/app/Formal_Contacto_Emergencia/' : `/api/app/Funcional_Contacto_Emergencia/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_EMERGENCY_CONTANCT,
      payload: {
        emergencyContacts: resp.data.data,
        emergencyContactLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EMERGENCY_CONTANCT,
      payload: false
    });
  }
}



export const saveEmergencyContact = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_EMERGENCY_CONTACT,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Contacto_Emergencia/' : '/api/app/Funcional_Contacto_Emergencia/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { emergencyContacts, emergencyContactLength } = getState().emergencyContact;
    const aEmergencyContacts = [...emergencyContacts, resp.data];
    dispatch({
      type: actions.GET_EMERGENCY_CONTANCT,
      payload: {
        emergencyContacts: aEmergencyContacts,
        emergencyContactLength: emergencyContactLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_EMERGENCY_CONTACT,
      payload: false
    });
  }
}

export const editEmergencyContact = (data, id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_EMERGENCY_CONTACT,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(iType === 1 ? `/api/app/Formal_Contacto_Emergencia/${id}` : `/api/app/Funcional_Contacto_Emergencia/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { emergencyContacts, emergencyContactLength } = getState().emergencyContact;
    emergencyContacts[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_EMERGENCY_CONTANCT,
      payload: {
        emergencyContacts: emergencyContacts,
        emergencyContactLength: emergencyContactLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_EMERGENCY_CONTACT,
      payload: false
    });
  }
}

export const deleteEmergencyContact = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMERGENCY_CONTANCT,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Contacto_Emergencia/${id}` : `/api/app/Funcional_Contacto_Emergencia/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { emergencyContacts, emergencyContactLength } = getState().emergencyContact;
    emergencyContacts.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_EMERGENCY_CONTANCT,
      payload: {
        emergencyContacts: emergencyContacts,
        emergencyContactLength: emergencyContactLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EMERGENCY_CONTANCT,
      payload: false
    });
  }
}
